import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { setCookie } from '../../utils/CookieUtils';
import { RootState } from '../reduxStore';
import { history } from '../history';
import { hideLoader, showLoader } from './loaderSlice';
import { showErrorSnackbar, showSuccessSnackbar } from './snackbarSlice';
import { getUserUpdate } from '../../ApiServices/UpdatePasswordServices';
import { t } from 'i18next';

export interface Authorization {
  oldPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export interface AuthState {
  auth: Authorization;
  loading: boolean;
  error: string;
}

// initialize state from local storage to enable user to stay logged in
function createInitialState() {
  let savedAuth = localStorage.getItem('auth');
  return savedAuth === null
    ? { auth: { oldPassword: '', newPassword: '', confirmPassword: '' }, loading: false, error: '' }
    : { value: JSON.parse(savedAuth) };
}

// saving state data
function createReducers() {
  return { setAuth };
  function setAuth(state: any, action: any) {
    state.value = action?.payload;
  }
}

// implementation - methods without api calls
function createExtraActions() {
  return { logout: logout() };

  function logout() {
    return createAsyncThunk('logout', function(arg, { dispatch }) {
      dispatch(authActions.setAuth(undefined));
      localStorage.removeItem('auth');
      history.navigate('/login');
    });
  }
}

const getUpadatedUser = createAsyncThunk(
  'authorization/getUpdatedUser',
  async (payload: Authorization, { dispatch }) => {
    try {
      dispatch(showLoader({ message: t('AUTHENTICATING'), isLoading: true }));

      let response = await getUserUpdate(payload);
      let user = response?.data;

      dispatch(authActions.setAuth(user));

      dispatch(showSuccessSnackbar({ message: t('PASSWORD_UPDATED_SUCCESSFULLY_LOGGING_OUT') }));

      localStorage.removeItem('auth');
      localStorage.removeItem('stores');
      setCookie('admin_token', '');

      dispatch(authActions.logout());

      return user;
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
    } finally {
      dispatch(hideLoader());
    }
  }
);

const authorizationSlice = createSlice({
  name: 'authorization',
  initialState: createInitialState,
  reducers: createReducers
});

export default authorizationSlice.reducer;
export const authState = (state: RootState) => state?.auth;
export const authActions = {
  ...authorizationSlice.actions,
  ...createExtraActions(),
  getUpadatedUser
};
